import { ECOM_APP_DEF_ID, ECOM_CART_SECTION_ID } from '../const';
import { BusinessPropertyName, isPropertyEnabled } from '@wix/bookings-calendar-catalog-viewer-mapper';
export async function isCartEnabled(wixCodeApi, businessInfo) {
  if (isPropertyEnabled(businessInfo, BusinessPropertyName.IS_CART_ENABLED)) {
    return wixCodeApi.site.isAppSectionInstalled({
      sectionId: ECOM_CART_SECTION_ID,
      appDefinitionId: ECOM_APP_DEF_ID
    });
  }
  return false;
}
//# sourceMappingURL=isCartEnabled.js.map